import * as React from 'react';
import { cn } from './lib/utils';

const SIZE = {
  sm:      'h-4 w-4 border-2',
  default: 'h-7 w-7 border-2',
  lg:      'h-10 w-10 border-[3px]',
};

/**
 * Replaces .loading-container + .loading-spinner from App.css.
 */
function Spinner({ size = 'default', label, className }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 py-12',
        className
      )}
      role="status"
      aria-label={label ?? 'Loading'}
    >
      <span
        className={cn(
          'rounded-full border-surface border-t-aqua animate-nn-spin',
          SIZE[size]
        )}
        aria-hidden="true"
      />
      {label && (
        <span className="text-body text-text-muted">{label}</span>
      )}
    </div>
  );
}

export { Spinner };
